import React from 'react';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import Main from './Main';
import injectTapEventPlugin from 'react-tap-event-plugin';

injectTapEventPlugin();


const App = () => (
  <MuiThemeProvider muiTheme={getMuiTheme(
    {
      slider: {
        selectionColor: '#333',
        handleFillColor: '#333'
      }
    }
  )}>
    <Main />
  </MuiThemeProvider>
);


export default App;



// WEBPACK FOOTER //
// ./src/App.js